// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__AN13K","label":"LabeledBox_label__1TY6n"};